import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class ConsultaCepService {
  constructor(private http: HttpClient) {}

  getConsultaCep(cep: string) {
    return this.http.get(`https://viacep.com.br/ws/${cep}/json`, httpOptions);
  }
}
